import { NavLink } from "react-router-dom";

function navClass({ isActive }) {
  return [
    "block rounded-lg px-3 py-2 text-sm transition border",
    isActive
      ? "bg-[var(--accent)]/15 text-[var(--accent)] border-[var(--accent)]/30"
      : "text-[var(--text-secondary)] hover:bg-white/5 border-transparent",
  ].join(" ");
}

/**
 * @param {{ showUsersTab: boolean }} props
 */
export default function SettingsNav({ showUsersTab }) {
  return (
    <nav className="space-y-1" aria-label="Settings sections">
      <NavLink to="/settings?tab=profile" className={navClass} end={false}>
        My Profile
      </NavLink>
      {showUsersTab ? (
        <NavLink to="/settings?tab=users" className={navClass}>
          Users
        </NavLink>
      ) : null}
    </nav>
  );
}
